import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
// import Home from './views/Home.vue';

Vue.use(Router);

// for public
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.tokenscr) {
    next();
    return;
  } else {
    next('/');
  }
};
// for user
const ifAuthenticated = (to, from, next) => {
  if (store.getters.tokenscr) {
    next();
    return;
  }
  next('/login');
};
// for user
const ifAuthenticatedUser = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'user') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/login');
};
// for company
const ifAuthenticatedCompany = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'company') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};
// for jobseeker
const ifAuthenticatedJs = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'jobseeker') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};
// for admin
const ifAuthenticatedAdmin = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'admin') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Topic',
      component: () => import('./views/Topic.vue'),
    },
    {
      path: '/topic/detail',
      name: 'Topicdetail',
      component: () => import('./views/Topicdetail.vue'),
    },
    {
      path: '/question',
      name: 'Question',
      component: () => import('./views/Question.vue'),
    },
    {
      path: '/question/detail',
      name: 'Questiondetail',
      component: () => import('./views/Questiondetail.vue'),
    },
    {
      path: '/kamus',
      name: 'Kamus',
      component: () => import('./views/Kamus.vue'),
    },
    {
      path: '/acronym',
      name: 'Acronym',
      component: () => import('./views/Acronym.vue'),
    },
    {
      path: '/funfact',
      name: 'Funfact',
      component: () => import('./views/Funfact.vue'),
    },
    {
      path: '/trend',
      name: 'Trend',
      component: () => import('./views/Trend.vue'),
    },
    {
      path: '/trivia',
      name: 'Trivia',
      component: () => import('./views/Trivia.vue'),
    },
    {
      path: '/favorite',
      name: 'Kamusfavorite',
      component: () => import('./views/Kamusfavorite.vue'),
    },
    {
      path: '/history',
      name: 'Kamushistory',
      component: () => import('./views/Kamushistory.vue'),
    },
    {
      path: '/kamus/detail',
      name: 'Kamusdetail',
      component: () => import('./views/Kamusdetail.vue'),
    },
    {
      path: '/admin/kamus',
      name: 'KamusAdmin',
      component: () => import('./views/admin/Kamus.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/grammar',
      name: 'TopicAdmin',
      component: () => import('./views/admin/Topic.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/question',
      name: 'QuestionAdmin',
      component: () => import('./views/admin/Question.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin',
      name: 'Login',
      component: () => import('./views/Login.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/change-password',
      name: 'Changepassword',
      component: () => import('./views/Changepass.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '*',
      name: 'Notfound',
      component: () => import('./views/Notfound.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
